import React, { useEffect, useState } from 'react'
import { DownArrowIcon } from '../../svg'
import {
  MobileNavAccordionBody,
  MobileNavAccordionButton,
  MobileNavNestedAccordionButton,
  MobileNavNestedBody,
} from './atoms'

interface MobileNavAccordionProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  nested?: boolean
  onOpenChange?: (open: boolean) => void
}

export const MobileNavAccordion = ({
  title,
  children,
  defaultOpen = false,
  nested = false,
  onOpenChange,
}: MobileNavAccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  useEffect(() => {
    onOpenChange?.(isOpen)
  }, [isOpen, onOpenChange])
  const Button = nested ? MobileNavNestedAccordionButton : MobileNavAccordionButton
  const Body = nested ? MobileNavNestedBody : MobileNavAccordionBody

  return (
    <>
      <Button
        type='button'
        $isOpen={isOpen}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {title}
        <DownArrowIcon />
      </Button>
      {isOpen ? <Body>{children}</Body> : null}
    </>
  )
}
